<template>
  <div class="c-campaign-config-form">
    <el-form
        ref="form"
        :model="campaignConfigForm"
        label-position="top"
        label-width="120px"
        @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="Campaign Name">
            <el-input v-model="campaignConfigForm.name" class="gray"></el-input>
          </el-form-item>
        </el-col>

        <!--        <el-col :span="5" :offset="1">-->
        <!--          <el-form-item label="Don't show to EU users">-->
        <!--            <el-switch v-model="campaignConfigForm.block_eu"></el-switch>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->

        <el-col :span="5" :offset="1">
          <el-form-item label="Don't show Onvocado watermark">
            <el-switch v-model="hasWatermark" :inactive-value="false" :active-value="true"></el-switch>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { errorMessages } from '@meta/errorMessages'

export default {
  name: 'CampaignConfigForm',
  data() {
    return {
      enableUpdate: false,
      errorMessages: errorMessages,
      campaignConfigForm: {
        name: '',
        block_eu: false,
        has_watermark: false,
      },
    }
  },
  computed: {
    ...mapState('users', {
      currentUser: (state) => state.currentUser,
    }),
    campaign() {
      return this.$store.getters['campaign/targetCampaign']
    },
    hasWatermark: {
      get: function () {
        return this.campaignConfigForm.has_watermark
      },
      set: function (removeWatermark) {
        if (removeWatermark) {
          if (this.currentUser.subscription.features.includes('NO_WATERMARK')) {
            this.campaignConfigForm.has_watermark = removeWatermark
          } else {
            this.$message({
              type: 'error',
              message: errorMessages.feature.limits.watermark,
            })
          }
        } else {
          this.campaignConfigForm.has_watermark = removeWatermark
        }
      },
    },
  },
  watch: {
    campaign(newVal) {
      const isNameChanged = this.campaignConfigForm.name !== newVal.name
      const isBlockEuChanged = this.campaignConfigForm.block_eu !== newVal.block_eu
      const isHasWatermarkChanged = this.campaignConfigForm.has_watermark !== newVal.has_watermark

      if (isNameChanged || isBlockEuChanged || isHasWatermarkChanged) {
        this.setFormValues(newVal)
      }
    },
    campaignConfigForm: {
      handler() {
        if (this.enableUpdate) {
          this.$emit('update', this.campaignConfigForm)
        }
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    this.setFormValues(this.campaign)
    this.$nextTick(() => {
      this.enableUpdate = true
    })
  },
  methods: {
    setFormValues(campaign) {
      const newValue = JSON.parse(JSON.stringify(campaign))
      this.campaignConfigForm.name = newValue.name
      this.campaignConfigForm.block_eu = newValue.block_eu
      this.campaignConfigForm.has_watermark = newValue.has_watermark

      if (newValue.has_watermark && !this.currentUser.subscription.features.includes('NO_WATERMARK')) {
        this.campaignConfigForm.has_watermark = false
      }
    },
  },
}
</script>

<style lang="scss">
.c-campaign-config-form {
  .el-form .el-form-item {
    label {
      @apply font-medium;
    }
  }
}
</style>